import styled from "styled-components";

export const StyledCoverImage = styled.img<{ src: string }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
`;

export const StyledImageWrapper = styled.div`
  height: 300px;
`;
